// calculate the reader's accuracy based on totalErrors
// and returns a percentage based number
export function calculateAccuracy(totalErrors){
  totalErrors = Array.isArray(totalErrors) ? totalErrors : [];
  let totalWords = 0;
  let totalCorrect = 0;
  for(let i = 0; i < totalErrors.length; i++){
    let pageErrors = totalErrors[i];
    if(!pageErrors) continue // OR should it push an empty array or something else?
    for(let j = 0; j < pageErrors.length; j++){
      let phraseErrors = pageErrors[j];
      if(!phraseErrors) continue // OR should it push an empty array or something else?
      for(let k = 0; k < phraseErrors.length; k++){
        totalWords += 1;
        if(!phraseErrors[k]){
          totalCorrect += 1;
        }
      }
    }
  }
  if(totalWords <= 0){
    return 0;
  }
  return Math.floor((totalCorrect/totalWords)*100);
}

export function getNonFlaggedErrors(errors,flaggedPhrases){
  let adjustedErrors = errors[0].filter((error,index)=>{
    if(flaggedPhrases[index]){
      return !flaggedPhrases[index].triggered;
    }else{
      return true;
    }
  });

  return [adjustedErrors];
}

export function calculateAccuracyFromScoredTranscript(scoredTranscript){
  let totalErrors = scoredTranscript.map((page) => page.map((phraseScore) => phraseScore.totalErrors));
  return calculateAccuracy(totalErrors);
}